import { TextButton } from '@/components/common/TextButton/TextButton';
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';

type FooterLinkPath = {
  label: string;
  href: string;
};

export function GlobalFooter() {
  const t = useTranslations('common.globalFooter');

  const footerLinks: FooterLinkPath[] = [
    { label: t('links.about'), href: 'https://hallo.mercari.com/' },
    { label: t('links.news'), href: 'https://hallo.mercari.com/news' },
    { label: t('links.privacy'), href: 'https://hallo.mercari.com/privacy' },
    { label: t('links.jobCategories'), href: 'https://hallo.mercari.com/jobtypes' },
    { label: t('links.trademark'), href: 'https://hallo.mercari.com/trademark' },
    { label: t('links.pressKit'), href: 'https://about.mercari.com/press/press-kit/mercarihallo/' },
    { label: t('links.company'), href: 'https://about.mercari.com/about/company/' },
    { label: t('links.termsCrew'), href: 'https://hallo.mercari.com/tos/crew' },
    { label: t('links.termsPartner'), href: 'https://hallo.mercari.com/tos/partner' },
    {
      label: t('links.operationsRegulations'),
      href: 'https://hallo.mercari.com/rules-of-business-operations',
    },
    { label: t('links.safety'), href: 'https://hallo.mercari.com/safety' },
  ];

  return (
    <footer className="w-full border-t-thin border-t-neutral-auxiliary bg-neutral-white py-8 px-6 flex flex-col gap-3">
      <div className="text-neutral-primary text-small font-bold">{t('copyright')}</div>
      <div className="flex flex-wrap gap-x-3">
        {footerLinks.map((link) => (
          <Link key={link.href} href={link.href} target="_blank">
            <TextButton size="small" variant="neutral">
              {link.label}
            </TextButton>
          </Link>
        ))}
      </div>
      <div className="text-neutral-tertiary text-tiny">{t('license')}</div>
    </footer>
  );
}
